module.exports = __webpack_public_path__ + "media/assets/icons/configuration-22f0c4cf7c0a839ceb242b55f16db7f9.svg";